import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { API_URL } from "utils/ApiUrl";

const useFetchAdminStats = () => {
  const [adminStats, setAdminStats] = useState();
  const history = useHistory();
  const fetchAdminStats = async () => {
    const accessToken = localStorage.getItem("token");

    try {
      const response = await axios.get(`${API_URL}/users/admin-stats`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = response?.data?.data;
      //   console.log("Admin Stats : ", response);
      setAdminStats(data);
    } catch (e) {
      if (e.status == 401) {
        localStorage.clear();
        toast.error("Session timed out. Please Login again.");
        history.push("/adminlogin/dashboard");
      }
      if (e?.response) console.log("Error response Admin Stats :", e?.response);
      else console.error("Error during API call Admin Stats :", e);
    }
  };

  useEffect(() => {
    fetchAdminStats();
  }, []);

  return adminStats;
};

export default useFetchAdminStats;
